import classNames from "classnames";
import { FC, ReactNode } from "react";

const Skewer: FC<{ angle?: number; children?: ReactNode; className?: string }> = ({ angle = -3, children, className = "" }) => {
  return (
    <div
      className={classNames(`bg-background-primary-lighter text-font-active inline-block font-poppins font-semibold italic rounded-xs`, className)}
      style={{ transform: `rotate(${angle}deg)` }}
    >
      {children}
    </div>
  );
};

export default Skewer;
